export const TENANT_CURRENCY = "USD";
